import Axios from '@/components/api/axios.js'

/**********************************************************************************
 * svg
 **********************************************************************************/
export default {
	/**
	 * 获取svg图树
	 */
	getSvgTree: (success, failure) => {
		Axios.post('/svg/getSvgTree.do', {}, success, failure)
	},
	/**
	 * 根据pageId获取svg图详细信息
	 * @param {String} pageId svg图名称（同时也是主键）
	 */
	get: (pageId, success, failure) => {
		Axios.post('/svg/get.do', {
			pageId
		}, success, failure)
	},
}